import axios from 'axios';
const API_CC_URL = import.meta.env.VITE_CC_URL;

const specialApplicationService = {
    getSpecialApplication: () => {
      return axios.get(`${API_CC_URL}/SpecialApplication`,{
        headers: {
          UserAgent:'PC'
        },
        auth:{
           username:"CBD0FD46-899D-4915-A1BE-CA7359E346D6",
           password:"CBD0FD46-899D-4915-A1BE-CA7359E346D6"
        }
      
      });
    }
};
export default specialApplicationService;